import { Box, FormControl, Grid, InputLabel, MenuItem, Paper, Select, Typography } from "@mui/material";
import { Api } from "queries/types";
import { useTranslation } from "react-i18next";
import { ShopIPComparatorState } from "./useShopIPComparator";
import SyncAltSharpIcon from '@mui/icons-material/SyncAltSharp';

interface ShopIPComparatorProps {
    shop: Api.Shop;
    shopIPComparator: ShopIPComparatorState;
    setShopIPComparator: React.Dispatch<React.SetStateAction<ShopIPComparatorState>>;
}

function getStyles(isActive: Boolean) {
    return {
        fontWeight: isActive ? 700 : 'normal',
        color: isActive ? 'green' : 'initial',
    };
}

const ShopInventoryProposalComparator = ({ shop, shopIPComparator, setShopIPComparator }: ShopIPComparatorProps) => {
    const { t } = useTranslation();

    return (
        <Box mt={2} mb={2}>
        <Paper sx={{ p: 1, pt: 2,  m: 0, marginX: 'auto' }}>
            <Grid container spacing={3} justifyContent="center" alignItems="center">
                <Grid item xs={12} sm={3}>
                    <Typography fontSize="14px" fontWeight="600">{t("shop.inventory_proposal.comparatorTitle")}</Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FormControl fullWidth size="small">
                        <InputLabel>{t("shop.inventory_proposal.labelSource")}</InputLabel>
                        <Select
                            fullWidth
                            label={t("shop.inventory_proposal.labelSource")}
                            onChange={(e) =>
                                setShopIPComparator({ ...shopIPComparator, sourceId: e.target.value !== "" ? (e.target.value as number) : undefined })
                            }
                            value={shopIPComparator.sourceId || ""}
                        >
                            {shop.shopGrids.filter(shopGrid => shopGrid.id !== shopIPComparator.targetId).map((shopGrid) => (
                                <MenuItem key={shopGrid.id} value={shopGrid.id} style={getStyles(shopGrid.isActive)}>
                                    {shopGrid.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={1} sx={{ display: {xs:'none', md: 'flex'}, justifyContent: 'center', alignSelf: 'center'}} alignItems="center"><SyncAltSharpIcon  sx={{ fontSize: 24 }} /></Grid>
                <Grid item xs={12} sm={4}>
                    <FormControl fullWidth size="small">
                        <InputLabel>{t("shop.inventory_proposal.targetSource")}</InputLabel>
                        <Select
                            fullWidth
                            label={t("shop.inventory_proposal.targetSource")}
                            onChange={(e) =>
                                setShopIPComparator({ ...shopIPComparator, targetId: e.target.value !== "" ? (e.target.value as number) : undefined })
                            }
                            value={shopIPComparator.targetId || ""}
                        >
                            {shop.shopGrids.filter(shopGrid => !shopGrid.isActive).map((shopGrid) => (
                                <MenuItem key={shopGrid.id} value={shopGrid.id} style={getStyles(shopGrid.isActive)}>
                                {shopGrid.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
            </Grid>
        </Paper>
        </Box>
    );
};

export default ShopInventoryProposalComparator;
